/**
 * 班次类型 code → 当前界面语言的字典标签（shift_type 的 labelI18n）。
 *
 * 排班页 Gantt、My Shift（月/周/日详情/我的请求）、Shift Requests 列表与审核弹窗、Dashboard
 * 团队卡以前直接把 code（morning / full_day）或首字母大写的 code（Morning）显示给用户，中文界面
 * 也是英文。这里只是 useSystemLookupLabel('shift_type') 的薄封装，不是另一套取数：
 *   - 字典有该 code → labelI18n[locale]（缺译回落英文 label）
 *   - 字典未加载 / 没有该 code → code 转成可读英文（full_day → Full day），不把下划线原样露出
 *   - 没有 code → 空串，由调用方决定占位
 */
import { useCallback } from 'react'
import { useSystemLookupLabel } from '@/hooks/useLookupLabel'

/** 字典查不到时的兜底：下划线变空格、首字母大写（full_day → Full day）。 */
export function humanizeShiftTypeCode(code: string): string {
  const s = code.replace(/_/g, ' ').trim()
  return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : ''
}

export function useShiftTypeLabel(): (code?: string | null) => string {
  const lookupLabel = useSystemLookupLabel('shift_type')
  return useCallback(
    (code?: string | null) => {
      if (!code) return ''
      const label = lookupLabel(code)
      return label && label !== code ? label : humanizeShiftTypeCode(code)
    },
    [lookupLabel],
  )
}
